import { Injectable } from '@angular/core'
import { type Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { HashingService } from './hashing.service'
import { TokenService } from './token.service'
import type { hr as cpt } from 'efd-cpt-backend-interfaces-ts'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { SharedService } from './shared.service'

export type TiresStockDTO =
  cpt.emilfreydigital.customer_portal_backend.rest.vehicles.dto.VehicleTiresStockDto
export type TyreDTO =
  cpt.emilfreydigital.customer_portal_backend.rest.vehicles.dto.VehicleTireDto
export type TiresAppointmentDTO =
  cpt.emilfreydigital.customer_portal_backend.rest.appointment.dto.TiresAppointmentUrlDto

export interface ITiresService {
  getTires: (vin: string) => Observable<TiresStockDTO>
}

@Injectable({
  providedIn: 'root'
})
export class TiresService implements ITiresService {
  private readonly apiUrl

  constructor(
    private readonly http: HttpClient,
    private readonly hashingService: HashingService,
    private readonly tokenService: TokenService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>,
    private readonly sharedService: SharedService
  ) {
    this.apiUrl = this.remoteConfigService.get('backend.url')
  }

  getTires(vin: string): Observable<TiresStockDTO> {
    return this.http.get<TiresStockDTO>(`${this.apiUrl}/v1/vehicles/${vin}/tires`)
  }

  /**
   *
   * now it covers all services, not only tires
   */
  tireAppointmentLink(vin: string): Observable<TiresAppointmentDTO> {
    const token = this.tokenService.getToken()
    const lang = this.sharedService.currentLanguage()

    return this.http.get<TiresAppointmentDTO>(
      this.apiUrl + '/appointment/tires/' + vin,
      {
        params: { c: this.hashingService.hashCode(token.cp_id), lang }
      }
    )
  }
}
